import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

const Actions = ({ nextClickHandler, buttonName, finish = false }) => (
  <div className="bmc-page-actions mt-16 flex justify-end">
    <Button
      className=""
      onClick={nextClickHandler || undefined}
      disabled={!nextClickHandler}
      // tooltipIfDisabled={tooltipIfDisabled}
      // tooltipDelayHide={TOOLTIP_DELAY}
    >
      {finish || buttonName}
    </Button>
  </div>
);

Actions.propTypes = {
  buttonName: PropTypes.string.isRequired,
};

export default Actions;
